import { useKeycloak } from "@react-keycloak/web";
import PrivateLayout from "../templates/PrivateLayout";

const PrivateRoute = ({ children }) => {
    const { keycloak } = useKeycloak();

    const isLoggedIn = keycloak.authenticated;

    return isLoggedIn ? <PrivateLayout>{children}</PrivateLayout> : keycloak.login();
};

export default PrivateRoute;